import { AgentEffectDescription, Card, Player } from "~/business";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { Colors, Spacing } from "~/jsx/theme";
import { RauriRandom, XPackBy, useModal } from "~/utils";
import { XAgentEffect } from "./XAgentEffect";
import { XButton } from "./XButton";
import { XCard } from "./XCard";
import { XPlayerIcon } from "./XPlayerIcon";
import { XTechTile } from "./XTechTile";
import { XTypography } from "./XTypography";
import { XSignetSvg } from "./svg";

export const XPlayerLeaderDescription = ({ player }: { player: Player }) => {
  const { hide: hideFaction } = useModal(ModalNames.playerLeader);
  const viewingPlayer = useViewingPlayerOpt();
  const { onPlayGlobalEffect } = useActions();
  const {
    playerLeader,
    id,
    name: playerName,
    techTiles,
    ownedCards,
    trashZone,
    discard,
  } = player;
  const { name: factionName, signetRing, globalEffect } = playerLeader;

  const isViewingPlayer = viewingPlayer?.id === player.id;

  const onGlobalEffect =
    isViewingPlayer && onPlayGlobalEffect
      ? () => {
          hideFaction();
          onPlayGlobalEffect();
        }
      : undefined;

  const globalEffectNode = (
    <XAgentEffect
      effectDescription={globalEffect}
      width={32}
      color={Colors.common.black}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
      context="card"
    />
  );

  return (
    <div
      style={{
        padding: Spacing.px24,
        maxWidth: "100vw",
        width: 969,
        overflowY: "scroll",
        maxHeight: "90vh",
      }}
    >
      <XTypography>
        <XPlayerIcon width={18} playerId={id} /> {playerName} plays as{" "}
        <b>{factionName}</b>
      </XTypography>
      <XTypography style={{ marginTop: Spacing.px24 }}>
        <XSignetSvg
          width={32}
          style={{ display: "inline-block", verticalAlign: "middle" }}
        />
        :{" "}
        <XAgentEffect
          effectDescription={signetRing}
          width={32}
          color={Colors.common.black}
          style={{
            display: "inline-block",
            verticalAlign: "middle",
          }}
          context="card"
        />
      </XTypography>
      <XTypography style={{ marginTop: Spacing.px12 }}>
        Permanent effect:
        <br />
        {AgentEffectDescription.is(globalEffect, "masterstroke") ? (
          <XButton style={{ width: "fit-content" }} onClick={onGlobalEffect}>
            {globalEffectNode}
          </XButton>
        ) : (
          globalEffectNode
        )}
      </XTypography>
      <Cards
        cards={ownedCards.filter((card) => !discard.pile.includes(card))}
        label="Cards"
      />
      <Cards cards={discard.pile} label="Discarded cards" />
      <Cards cards={trashZone.pile} label="Trashed cards" />
      {techTiles.length > 0 && (
        <>
          <XTypography style={{ marginTop: Spacing.px12 }}>
            Technologies :
          </XTypography>
          <XPackBy packSize={3} gap={10}>
            {techTiles.pile.map((tech) => (
              <XTechTile key={tech.id} techTile={tech} />
            ))}
          </XPackBy>
        </>
      )}
    </div>
  );
};

const Cards = ({ cards, label }: { cards: Card[]; label: string }) => {
  if (!cards.length) {
    return null;
  }
  return (
    <XTypography style={{ marginTop: Spacing.px12 }}>
      {label}:{" "}
      <XPackBy packSize={5} gap={10}>
        {RauriRandom.fromFixedSeed(cards.map((card) => card.id).join("_"))
          .shuffle([...cards])
          .map((card) => (
            <XCard
              key={card.id}
              card={card}
              width={160}
              removeAnimationId={true}
            />
          ))}
      </XPackBy>
    </XTypography>
  );
};
